import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  const navClasses = isHome && !isScrolled
    ? 'fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-transparent'
    : 'fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50 border-b border-foreground-100/20';

  return (
    <nav className={navClasses}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center gap-2 flex-shrink-0">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-sm text-background-50"></i>
              </div>
              <span className={`text-lg font-bold font-heading whitespace-nowrap ${isHome && !isScrolled ? 'text-background-50' : 'text-foreground-900'}`}>
                51吃瓜爆料
              </span>
            </Link>
            <div className="hidden md:flex items-center gap-1">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? isHome && !isScrolled ? 'bg-background-50/20 text-background-50' : 'bg-primary-100 text-primary-700'
                      : isHome && !isScrolled ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <div className="relative group">
                <button className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 flex items-center gap-1 whitespace-nowrap cursor-pointer ${
                  isHome && !isScrolled ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}>
                  更多 <i className="ri-arrow-down-s-line text-xs"></i>
                </button>
                <div className="absolute top-full left-0 mt-1 w-36 bg-background-50 rounded-lg border border-foreground-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  {categories.slice(5).map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer first:rounded-t-lg last:rounded-b-lg"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {searchOpen && (
              <div className="hidden md:flex items-center">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索爆料..."
                  className="w-48 px-3 py-1.5 text-sm rounded-full border border-foreground-200 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  autoFocus
                />
              </div>
            )}
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                isHome && !isScrolled ? 'text-background-50 hover:bg-background-50/10' : 'text-foreground-600 hover:bg-background-100'
              }`}
              aria-label="搜索"
            >
              <i className={`${searchOpen ? 'ri-close-line' : 'ri-search-line'} text-lg`}></i>
            </button>

            <Link
              to="/about"
              className={`hidden md:inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !isScrolled
                  ? 'bg-background-50/15 text-background-50 border border-background-50/20 hover:bg-background-50/25'
                  : 'btn-dark'
              }`}
            >
              爆料投稿 <i className="ri-send-plane-line"></i>
            </Link>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                isHome && !isScrolled ? 'text-background-50 hover:bg-background-50/10' : 'text-foreground-600 hover:bg-background-100'
              }`}
              aria-label="菜单"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-foreground-100 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3">
            <input
              type="text"
              placeholder="搜索爆料..."
              className="w-full px-3 py-2 text-sm rounded-full border border-foreground-200 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 mb-3"
            />
            <div className="flex flex-col gap-0.5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-2.5 text-sm rounded-lg transition-colors cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="mt-2 px-3 py-2.5 text-sm rounded-lg bg-primary-500 text-background-50 font-medium text-center cursor-pointer"
              >
                爆料投稿
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}